import api from '@/js/services/api';

export default {

    getListOfStates() {
        return api().get('/states/get')
    },

    getListOfPositions() {
        return api().get('/user/positions/get')
    },

    getListOfLicenses() {
        return api().get('/user/licenses/get')
    },

    getListOfLanguages() {
        return api().get('/user/languages/get')
    },

    getListOfVariantsHowHear() {
        return api().get('/user/how-hear/get')
    },

    getListOfCountries() {
        return api().get('/countries/get')
    },

    getApplicantsList() {
        return api().get('/master-admin/applicants/get?sortDir=asc&sortBy=name')
    },

    getClientsList() {
        return api().get('/master-admin/sites-clients/get?sortDir=asc&sortBy=name&withoutPagination=true')
    },
    getActiveClients() {
        return api().get('/master-admin/sites-clients/get?sortDir=asc&sortBy=name&withoutPagination=true&status=active')
    },

    getUserInfo() {
        return api().get('/user/get-current-user');
    },

    getUniformsList() {
        return api().get('/master-admin/uniforms/get?sortDir=asc&sortBy=title&withPagination=0');
    },

    getUniformsListForApplicant() {
        return api().get('/applicant/get/uniforms/list');
    },


    getListOfTags(search) {
        return api().get('/master-admin/tags/get?withPagination=0', search )
    },

    getListOfActiveUsers() {
        return api().get('/user/get-active-users')
    },

    searchUser(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/users/search?` + searchParams.toString())
    },

    searchApplicant(search) {
        const searchParams = new URLSearchParams({ search });
        return api().get(`/master-admin/applicants/no-pagination/get?` + searchParams.toString());
    }





}
